import React from 'react';
import { useHistory } from 'react-router';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { ButtonGroup } from '@material-ui/core';

import apiRoutes from '../../../config/api/routes';
import { useI18nPath } from '../../../config/clientRoutes/hooks';
import { ForgotPasswordRequest } from '../../../config/api/models/ForgotPassword';
import { useFetch } from '../../shared';
import {
  Button,
  LinkButton,
  Paragraph,
  Icons,
  FormControl,
  Message,
  TextFieldAdapter,
  validations,
} from '../../shared/components';

const ForgotPasswordForm = () => {
  const [forgotPasswordResponse, forgotPassword] = useFetch(apiRoutes.forgotPassword(), {
    method: 'POST',
  });
  const { t } = useTranslation();
  const { getPath } = useI18nPath();
  const { push } = useHistory();

  return forgotPasswordResponse && forgotPasswordResponse.success ? (
    <>
      <Paragraph>{t('security.forgotPassword.mailWasSent')}</Paragraph>
      <ButtonGroup>
        <Button onClick={() => push(getPath('login'))} icon={Icons.SUBMIT}>
          {t('security.forgotPassword.toLoginBtn')}
        </Button>
      </ButtonGroup>
    </>
  ) : (
    <Form
      onSubmit={(values: ForgotPasswordRequest) => {
        forgotPassword({ body: values });
      }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Paragraph>{t('security.forgotPassword.intro')}</Paragraph>
          <FormControl label={t('shared.forms.email')} id="email" required>
            <Field
              name="email"
              component={TextFieldAdapter}
              validate={validations(t).isEmail()}
              type="email"
            />
          </FormControl>
          <ButtonGroup>
            <Button type="submit" icon={Icons.SUBMIT}>
              {t('shared.forms.send')}
            </Button>
            <LinkButton to="login">{t('security.forgotPassword.toLoginBtn')}</LinkButton>
          </ButtonGroup>
          {forgotPasswordResponse && forgotPasswordResponse.error && (
            <Message type="error">{t(forgotPasswordResponse.reason)}</Message>
          )}
        </form>
      )}
    />
  );
};

export default ForgotPasswordForm;
